let styles = {
    container: {
        background: 'white',
        // padding: '2%',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
        background: '#7d3cff',
    },
    title: {
        textAlign:'center',
        fontSize:'16px',
        background:'#115691',
        padding:'5px',
        marginTop:'2%',
    },
    row: {
        margin:'1% 0%',
        fontSize:'15px',
        fontWeight:'600'
    },
    buddiesContainer: {
        padding: '1% 2%',
        // borderRadius: '8px',
        // boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    heading: {
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '2px solid #ccc',
        paddingBottom: '10px',
        margin: '0 0 2% 0',
        textAlign: 'start',
        color: '#115691'
    },
    page: {
        width: '100%',
    },
    card: {
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #e6e9f0',
        padding: '20px 22px',
        marginBottom: '16px',
    },
    cardTitle: {
        margin: '0 0 14px 0',
        fontSize: '16px',
        fontWeight: 700,
        color: '#115691',
    },
    roleGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px 20px',
        padding: '8px 0',
        borderBottom: '1px solid #eef1f6',
        fontSize: '14px',
    },
    roleTitle: {
        fontSize: '12px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: '#8a96a8',
        minWidth: '160px',
        paddingTop: '2px',
    },
    namesList: {
        color: '#1f2d3d',
        flex: 1,
        lineHeight: 1.5,
    },
    amenitiesList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
    },
    amenityItem: {
        padding: '5px 12px',
        fontSize: '13px',
        color: '#115691',
        background: '#eaf2fb',
        borderRadius: '999px',
    },
    noAmenities: {
        fontSize: '14px',
        color: '#8a96a8'
    },
  imageGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px'
  },
  imageThumb: {
    width: '160px',
    height: '120px',
    objectFit: 'cover',
    borderRadius: '6px',
    border: '1px solid #dee2e6'
  }
};

export default styles



// WEBPACK FOOTER //
// ./src/app/views/centerportal/VenueInfo/style.js